import React, { useState, useEffect } from 'react';
import {
  IconFileOutline,
  IconFilePDFOutline,
  token,
} from '@zillow/constellation';
import styled from 'styled-components';

const FileItemPreviewImg = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  margin: auto;
`;

const FileItemPreviewIcon = styled.div`
  display: block;
  margin: auto;
  color: ${token('colors.blue400')};
`;

export interface Props {
  file: File;
}

function FilePreview({ file }: Props) {
  const fileType = file.type ?? '';
  const isImage = fileType.startsWith('image/');
  const FileIconComponent =
    fileType === 'application/pdf' ? IconFilePDFOutline : IconFileOutline;

  /**
   * Load the preview URL and clean it up carefully to avoid memory leaks.
   */
  const [previewUrl, setPreviewUrl] = useState('');
  useEffect(() => {
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => {
      URL.revokeObjectURL(url);
      setPreviewUrl('');
    };
  }, [file]);

  /**
   * If we fail to load the image, flip back to the default file icon.
   */
  const [hasImageLoadError, setHasImageLoadError] = useState(false);
  function handleOnError() {
    setHasImageLoadError(false);
  }

  return isImage && !hasImageLoadError ? (
    <FileItemPreviewImg src={previewUrl} onError={handleOnError} />
  ) : (
    <FileItemPreviewIcon>
      <FileIconComponent size="lg" />
    </FileItemPreviewIcon>
  );
}

export default FilePreview;
